export default __webpack_public_path__ + "static/media/slider9.b9d9a379.jpg";